export const LARGE_SIZE_LAYOUT = 0;
export const MEDIUM_SIZE_LAYOUT = 1;
export const SMALL_SIZE_LAYOUT = 2;
